import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async findByFiltro ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      data: filtro,
      url: `modeloDespacho/findByFiltro`
    })
    return data
  },
  async salvarModeloDespacho ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `modeloDespacho/salvarModeloDespacho`
    })
    return data
  },
  async excluirModeloDespacho ({ commit }, dados) {
    const data = await axios({
      method: 'get',
      url: `modeloDespacho/deleteModeloDespacho/${dados.id}`
    })
    return data
  },
  async getHeaderConfiguration ({ commit }) {
    const data = await axios({
      method: 'get',
      url: `modeloDespacho/getHeaderConfiguration`
    })
    return data
  },
  async findByFiltroSelecao ({ commit }, filtro) {
    const data = await axios({
      method: 'post',
      data: filtro,
      url: `modeloDespacho/findByFiltroSelecao`
    })
    return data
  },
  async buscarReurbColetivosPorMunicipio ({ commit }, municipioId) {
    const data = await axios({
      method: 'get',
      url: `modeloDespacho/reurbColetivos/${municipioId}`
    })
    return data
  },
  async previsualizarModelo ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `modeloDespacho/previsualizarModelo`
    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/modeloDespacho.js